<template>
  <div class="share-wrapper">
    <img class="logo" src="../../../static/images/logos.png">
    <p class="clock_in">坚持打卡天数</p>
    <p class="clock_days">{{data.days}}</p>
    <div class="card">
      <p class="sentence"><span class="quotation">“</span>{{data.sentence}}</p>
      <p class="head_img"><img :src="data.headPortrait" alt=""></p>
      <div class="learn_data">
        <p class="lesson">{{data.shareTxt}}</p>
        <div class="data_statistics">
          <div>
            <p>今日学习</p>
            <p><span class="num">{{data.todayMinutes}}</span>分钟</p>
          </div>
          <span class="borders"></span>
          <div>
            <p>超越用户</p>
            <p><span class="num">{{data.proportion}}</span>%</p>
          </div>
        </div>
      </div>
    </div>
    <div class="share_detail">
      <img class="share_qr" :src="data.shareQr">
      <div>
        <p class="share_title">{{data.shareTitle}}</p>
        <p class="share_cont">{{data.shareContent}}</p>
        <p class="share_note">{{data.shareNote}}</p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      data: ''
    };
  },
  mounted() {
    this.overview()
  },
  methods: {
    overview () {
      this.$api.OVERVIEW({
        system_order_num: this.$route.query.order_id,
        business_id: this.$route.query.bc_id,
        "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
      }).then((res) => {
        if (res.code == 0) {
          this.data = res.data
          var share = {
            share_qr: res.data.share_qr,
            share_title: res.data.share_title,
            share_note: res.data.share_note,
            share_content: res.data.share_content,
            action: 'getShare'
          }
          if (this.isAndroid) {
            window.androidJS.getShare(JSON.stringify(share));
          } else if (this.isiOS) {
            window.webkit.messageHandlers.jsCallOCFunction.postMessage(JSON.stringify(share));
          }
        } else if (res.code == 2) {
          this.$router.push({ path: "/" });
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
  .share-wrapper {
    width: 100%;
    min-height: 100%;
    background: url(./static/images/share.png);
    background-size: 100% 100%;
    padding-bottom: 240px;
    .logo {
      width: 211px;
      height: 48px;
      margin-top: 30px;
      margin-left: 50px;
    }
    .clock_in {
      font-size: 28px;
      color: #ffffff;
      text-align: center;
      margin-top: 55px;
    }
    .clock_days {
      color: #ffffff;
      text-align: center;
      margin-top: 20px;
      font-size: 120px;
    }
    .card {
      position: relative;
      width: 634px;
      height: 640px;
      background: url(./static/images/card.png) no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      margin-top: 34px;
      padding-top: 60px;
    }
    .sentence {
      width: 370px;
      height: 98px;
      font-size: 26px;
      color: #ffffff;
      margin-left: 74px;
      .quotation {
        font-size: 60px;
      }
    }
    .head_img {
      position: absolute;
      top: 198px;
      left: 257px;
      width: 120px;
      height: 120px;
      border: 6px solid #ffffff;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .learn_data {
      text-align: center;
      margin-top: 210px;
      .lesson {
        font-size: 32px;
        font-weight: bold;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 47px;
        margin: 0 50px;
      }
      .data_statistics {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #666666;
        margin-top: 30px;
        div {
          font-size: 24px;
        }
        .num {
          font-size: 60px;
          font-weight: bold;
          color: #d44940;
        }
        .borders {
          width: 1px;
          height: 55px;
          border-left: 1px solid #e5e5e5;
          margin: 0 50px;
        }
      }
    }
    .share_detail {
      display: flex;
      justify-content: center;
      margin-top: 50px;
      color: #ffffff;
      .share_qr {
        width: 145px;
        height: 145px;
        border-radius: 20px;
        margin-right: 30px;
      }
      .share_title {
        font-size: 32px;
      }
      .share_cont {
        font-size: 24px;
        margin-top: 10px;
      }
      .share_note {
        text-align: center;
        font-size: 20px;
        background: #e18376;
        border-radius: 18px;
        padding: 8px 0;
        margin-top: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/share.vue